import React, { useEffect, useState } from "react"
import { Table, Col, Row } from "reactstrap"
import api from "API/Api"
import { Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"

const IncentiveTypes = props => {
  const { canAdd, canEdit, canDelete, MODULE } = usePermissions()
  const MID = MODULE.CONFIGURATIONS
  const user = localStorage.getItem("authUser")
  const userInfo = JSON.parse(user)
  const [fundTypes, setFundTypes] = useState([])
  const [desigId, setDesigId] = useState("")
  const [cell, setCell] = useState("")
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [active, setActive] = useState(false)
  const [search, setSearch] = useState({addincentiveType:''})
  const [checkedItems, setCheckedItems] = useState(new Array(fundTypes.length).fill(false))
  const [parentChecked, setParentChecked] = useState(false)
  const [load, setLoad] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [showFilter, setShowFilter] = useState(false)

  useEffect(() => { fetchData() }, [load])

  const fetchData = async () => {
    const response = await api.get("get-incentive-type/" + userInfo.uid)
    setFundTypes(Array.isArray(response.data.data) ? response.data.data : response.data.data?.data || [])
    setActive(true)
  }
  const fetchDelete = async () => {
    const r = await api.delete("delete-incentive-type/" + desigId)
    if (r.data.success === true) setLoad(!load)
  }
  const handleCheckboxChange = (i) => {
    const n = [...checkedItems]; n[i] = !n[i]; setCheckedItems(n)
    setParentChecked(n.every(item => item))
  }
  const handleParentCheckboxChange = () => {
    const v = !parentChecked; setParentChecked(v)
    setCheckedItems(new Array(fundTypes.length).fill(v))
  }
  const getSelectedUnitIds = async () => {
    const ids = fundTypes.map((f, i) => (checkedItems[i] ? f.id : null)).filter(id => id !== null)
    const r = await api.post("delete-multiple-incentivetype", { items: ids })
    if (r.data.success === true) setLoad(!load)
  }
  const removeFilter = () => { setSearch({addincentiveType:''}); setShowFilter(!showFilter) }

  return (
    <>
      <div className="dashBody">
        {canDelete(MID) && (
          <button className="delete-button" onClick={() => setconfirm_multiple_alert(true)}>
            <i className="fa fa-trash"></i>
          </button>
        )}
        <button className="filter_rel btn btn-primary" onClick={() => removeFilter()}>
          <i className="fa fa-filter"></i>
          {showFilter && <i className="rel_filter_ban fa fa-ban"></i>}
        </button>
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Additional Incentive Types</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              {canAdd(MID) && (
                <Link className="dashBtn" to="/add-incentive-type">
                  <i className="fas fa-plus-square"></i> Add New
                </Link>
              )}
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl" id="FundTypes">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckboxChange} /></th>
                <th>S.No</th>
                <th>Additional Incentive Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td>
                  <td><input type="text" className="form-control material_unit_type_sub"
                    onChange={e => setSearch({...search, addincentiveType: e.target.value})}
                    value={search.addincentiveType} placeholder="Search by incentive type" /></td>
                  <td><a className="btn btn-block btn-success applyFilter" title="Apply Filter"><i className="fa fa-search"></i> Apply</a></td>
                </tr>
              )}
              {fundTypes.length > 0 ? (
                fundTypes.filter(item =>
                  (item.incentive_type || "").toLowerCase().includes(search.addincentiveType.toLowerCase())
                ).map((fundType, i) => (
                  <tr key={i}>
                    <td><input type="checkbox" checked={checkedItems[i]} onChange={() => handleCheckboxChange(i)} /></td>
                    <td>{i + 1}</td>
                    <td>{fundType.incentive_type}</td>
                    <td>
                      {canEdit(MID) && <Link to={"/edit-incentive-type/" + fundType.id}><i className="fas fa-edit icons icon-edit"></i></Link>}
                      {canDelete(MID) && <i className="fas fa-trash-alt icons icon-delete"
                        onClick={() => { setDesigId(fundType.id); setCell(i + 1); setconfirm_alert(true) }}></i>}
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan={4} className="text-center">
                  {active ? "No Results Found!" : <img className="loaderImg" src={loader} alt="loading" />}
                </td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { fetchDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Incentive type deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {confirm_multiple_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { getSelectedUnitIds(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Incentive types deleted.") }}
          onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default IncentiveTypes
